import { Inject, Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { DOCUMENT } from '@angular/common';

@Injectable()
export class XcoScrollToService {
  dockedOffset: number; // data-scrollto-fixed Attribute with the css-selector as string: get height value of fixed elements on window
  duration: number; // Animation time: default value is 500
  targetValue: number; // css-selector from href attribute of event.target: gets offsetTop-Value
  start: number;
  scrolledEl = this.doc.scrollingElement || this.doc.documentElement;

  constructor(private router: Router, @Inject(DOCUMENT) private doc: any) {
    // scrolls to top after switching to the new route
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.scrolledEl.scrollTop = 0;
      }
    });
  }

  scrollTo(target, docked, duration) {
    if (typeof docked === 'string') {
      this.dockedOffset = this.getDockedElm(docked).clientHeight;
    } else if (typeof docked === 'number') {
      this.dockedOffset = docked;
    } else {
      this.dockedOffset = 0;
    }
    this.targetValue = (this.getOffsetTop(target) || 0) - this.dockedOffset;
    this.duration = duration || 500;
    this.smoothScroll();
  }

  private getDockedElm(docked) {
    const dockedCol = [];
    this.doc.querySelectorAll(docked).forEach(elm => {
      if (window.getComputedStyle(elm).display !== 'none') {
        dockedCol.push(elm);
      }
    });

    return dockedCol[0];
  }

  private getOffsetTop(elem) {
    let distance = 0;
    if (elem.offsetParent) {
      do {
        distance += elem.offsetTop;
        elem = elem.offsetParent;
      } while (elem);
    }
    return distance < 0 ? 0 : distance;
  }

  private smoothScroll() {
    const _this = this;
    const clock = Date.now();
    const requestAnimationFrame =
      window.requestAnimationFrame ||
      function(fn) {
        window.setTimeout(fn, 15);
      };
    this.start = this.scrolledEl.scrollTop;
    const step = () => {
      const elapsed = Date.now() - clock;
      this.scrolledEl.scrollTop = _this.position(elapsed);
      if (elapsed <= _this.duration) {
        requestAnimationFrame(step);
      }
    };
    step();
  }

  // ease in out function thanks to:
  // http://blog.greweb.fr/2012/02/bezier-curve-based-easing-functions-from-concept-to-implementation/
  private easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
  }

  /**
   * calculate the scroll position we should be in
   * given the start and end point of the scroll
   * the time elapsed from the beginning of the scroll
   * and the total duration of the scroll (default 500ms)
   */
  private position(elapsed) {
    if (elapsed > this.duration) {
      return this.targetValue;
    }
    return this.start + (this.targetValue - this.start) * this.easeInOutCubic(elapsed / this.duration);
  }
}
